import { render, staticRenderFns } from "./printSmallPayFeeList.vue?vue&type=template&id=4b130159&scoped=true"
import script from "./printSmallPayFeeList.vue?vue&type=script&lang=js"
export * from "./printSmallPayFeeList.vue?vue&type=script&lang=js"
import style0 from "./printSmallPayFeeList.vue?vue&type=style&index=0&id=4b130159&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b130159",
  null
  
)

export default component.exports